import { unref, type MaybeRef } from 'vue';

export type DisplayBadgeType = 'badge' | 'bg' | 'btn' | 'radio' | 'text';
export type DisplayBadgeColor =
  'primary' | 'secondary' | 'accent' | 'success' | 'warning' | 'error' | 'info' | 'neutral';

const colorClassLookup: Record<DisplayBadgeType, Record<DisplayBadgeColor, string>> = {
  badge: {
    primary: 'badge badge-primary',
    secondary: 'badge badge-secondary',
    accent: 'badge badge-accent',
    success: 'badge badge-success',
    warning: 'badge badge-warning',
    error: 'badge badge-error',
    neutral: 'badge badge-neutral',
    info: 'badge badge-info',
  },
  bg: {
    primary: 'bg-primary text-primary-content',
    secondary: 'bg-secondary text-secondary-content',
    accent: 'bg-accent text-accent-content',
    success: 'bg-success text-success-content',
    warning: 'bg-warning text-warning-content',
    error: 'bg-error text-error-content',
    neutral: 'bg-neutral text-neutral-content',
    info: 'bg-info text-info-content',
  },
  btn: {
    primary: 'btn btn-primary',
    secondary: 'btn btn-secondary',
    accent: 'btn btn-accent',
    success: 'btn btn-success',
    warning: 'btn btn-warning',
    error: 'btn btn-error',
    neutral: 'btn btn-neutral',
    info: 'btn btn-info',
  },
  radio: {
    primary: 'radio radio-primary',
    secondary: 'radio radio-secondary',
    accent: 'radio radio-accent',
    success: 'radio radio-success',
    warning: 'radio radio-warning',
    error: 'radio radio-error',
    neutral: 'radio radio-neutral',
    info: 'radio radio-info',
  },
  text: {
    primary: 'text-primary',
    secondary: 'text-secondary',
    accent: 'text-accent',
    success: 'text-success',
    warning: 'text-warning',
    error: 'text-error',
    neutral: 'text-neutral',
    info: 'text-info',
  },
};

export const useDisplayBadgeClass = (base: MaybeRef<DisplayBadgeType>) => {
  const getDisplayBadgeClass = (base: DisplayBadgeType, color: DisplayBadgeColor) =>
    colorClassLookup[base]?.[color] ?? '';

  const getColoredBadgeClass = (color: DisplayBadgeColor) =>
    getDisplayBadgeClass(unref(base), color);

  return {
    getDisplayBadgeClass,
    getColoredBadgeClass,
  };
};
